import { render, staticRenderFns } from "./UIAlert.vue?vue&type=template&id=557a04ae&"
import script from "./UIAlert.vue?vue&type=script&lang=ts&"
export * from "./UIAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports